import { connect } from "react-redux";
import Activities from "./Activities";

const mapState = ({ users }) => ({
  myActivities: users.myActivities,
  myData: users.myData,
});
export default connect(mapState)(Activities);
